// Traduccion de variables
const por = {
  test_more: '{{count}} one',
  test_more_plural: '{{count}} two',
  test: '{ {courseName} } oli'
}

export default por
